import { render } from "./TheTramXang.vue?vue&type=template&id=568f8a75"
import script from "./TheTramXang.vue?vue&type=script&lang=js"
export * from "./TheTramXang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__